let publicPath = process.env.BASE_URL;
export const fileData = {
  name: "测试文档xx测试文档xx测试文档xx测试文",
  descInfo: "测试文档xx测试文档xx测试文档xx测试文",
  previewType: "2",
  ext: "docx",
  extType: "doc",
  previewShow: `
    <div>测试文档xx测试文档xx测试文档xx测试文</div>
    <div>测试文档xx测试文档xx测试文档xx测试文</div>
    <div>测试文档xx测试文档xx测试文档xx测试文</div>
    <div>测试文档xx测试文档xx测试文档xx测试文</div>
    <div>测试文档xx测试文档xx测试文档xx测试文</div>
  `,
  previewCount: 10,
  downloadCount: 10,
  sizeText: "10M",
  dateText: "2020-10-10"
};

export const folderData = {
  downloadType: 0
};

export const fileListData = [
  {
    fileId: 1,
    name: "2015百度世界营销分论坛：索引商业世界",
    descInfo:
      "作为一年一度的营销行业盛会，9月8日，百度世界大会营销分论坛如约而至。在北京 JW万豪酒店，百度副总裁朱光、百度商业生态事业部总经理崔聿泓、百度大客户部总经理曾华等高管携手伊利集团副总裁兼企业策...",
    coverUrl: publicPath + "images/template/file-cover-default.png",
    iconUrl: publicPath + "images/file-icon/file-doc.png",
    detailUrl: "",
    previewCount: 10,
    downloadCount: 10,
    sizeText: "10M",
    dateText: "2020-10-10"
  },
  {
    fileId: 2,
    name: "百度新广告狂人收官 100余顶尖创意人过招",
    descInfo:
      "作为国内首个完全以技术创意为评判标准的广告奖项，不但叫好而且叫座，活动吸引了奥美、北京阳狮互动、Cheil、电通安吉斯集团在内100多家知名广告公司参与，而在香港、上海、广州的巡讲中也受到1000多两岸...",
    coverUrl: publicPath + "images/template/file-cover-default.png",
    iconUrl: publicPath + "images/file-icon/file-doc.png",
    detailUrl: "",
    previewCount: 10,
    downloadCount: 10,
    sizeText: "10M",
    dateText: "2020-10-10"
  },
  {
    fileId: 3,
    name: "百度熊贵成：百度手机助手月活破亿",
    descInfo:
      "9月8日，“新分发时代”2015百度世界·移动分发论坛在北京富力万丽酒店举行，百度移动分发事业部总经理熊贵成出席并致辞。他表示百度已实现了与91产品和团队的成功融合。目前百度手机助手已经成为单一品牌...",
    coverUrl: publicPath + "images/template/file-cover-default.png",
    iconUrl: publicPath + "images/file-icon/file-doc.png",
    detailUrl: "",
    previewCount: 10,
    downloadCount: 10,
    sizeText: "10M",
    dateText: "2020-10-10"
  },
  {
    fileId: 4,
    name: "百度熊贵成：百度手机助手月活破亿互联网盈利模式",
    descInfo:
      "9月8日，“新分发时代”2015百度世界·移动分发论坛在北京富力万丽酒店举行，百度移动分发事业部总经理熊贵成出席并致辞。他表示百度已实现了与91产品和团队的成功融合。目前百度手机助手已经成为单一品牌...",
    coverUrl: publicPath + "images/template/file-cover-default.png",
    iconUrl: publicPath + "images/file-icon/file-doc.png",
    detailUrl: "",
    previewCount: 10,
    downloadCount: 10,
    sizeText: "10M",
    dateText: "2020-10-10"
  }
];
